import { NavigateFunction, NavigateOptions, To, useNavigate } from 'react-router-dom';

import getIdentifier from './identifier-handler';

export function useKioskNavigate(): NavigateFunction {
    const navigate = useNavigate();
    const identifier = getIdentifier();
    return (to: To | number, options?: NavigateOptions) => {
        if (typeof to === 'string') {
            if (to.includes('?')) {
                if (!to.includes('&identifier=') && !to.includes('?identifier='))
                    return navigate(`${to}${identifier ? `&identifier=${identifier}` : ''}`, options);
                return navigate(to, options);
            } else {
                return navigate(`${to}${identifier ? `?identifier=${identifier}` : ''}`, options);
            }
        } else {
            return navigate(to as number);
        }
    };
}
